"use strict";

const getCurrentScriptOrigin = () => {
  if (typeof document === 'undefined') {
    return '/';
  }
  return document.currentScript?.baseURI || '/';
};
__webpack_public_path__ = getCurrentScriptOrigin();